import { useEffect, useReducer } from "react";

import { getFPAutoCompletePredictions } from "/geoservice";
import { useDebounce, useMounted } from "/hook";
import { reducer } from "/util";

import { Parameters, State } from "../useFPPlaceAutoComplete/useFPPlaceAutocomplete.types";

const useFPPlaceAutoComplete = ({ input }: Parameters) => {
  const debouncedInput = useDebounce(input);
  const [state, dispatch] = useReducer(reducer.reducer, reducer.initialState);
  const mountedRef = useMounted();

  useEffect(() => {
    dispatch({ type: reducer.actionTypes.INIT });
  }, []);

  useEffect(() => {
    if (!mountedRef.current) {
      return;
    }

    if (!debouncedInput) {
      dispatch({ type: reducer.actionTypes.INIT });
      return;
    }

    dispatch({ type: reducer.actionTypes.LOADING });

    getFPAutoCompletePredictions(debouncedInput, (predictions, status) => {
      if (mountedRef.current) {
        if (!predictions || status !== "ok") {
          dispatch({ type: reducer.actionTypes.FAILURE });
        } else {
          dispatch({ payload: predictions, type: reducer.actionTypes.SUCCESS });
        }
      }
    });
  }, [debouncedInput]);

  return state as State;
};

export default useFPPlaceAutoComplete;
